import React, { ReactElement } from 'react';
import TooltipInternal from '@mui/material/Tooltip';
import useStylesTooltip from './tooltip.styles';

const Tooltip: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const PLACEMENT_LEFT: TooltipPlacement = 'left';
  const PLACEMENT_LEFT_END: TooltipPlacement = 'left-end';
  const PLACEMENT_RIGHT: TooltipPlacement = 'right';

  const {
    isOpen,
    isDisabled,
    isInvisible,
    withArrow,
    withLeftPlacement,
    withLeftEndPlacement,
    withRightPlacement,
    title,
    component,
    children,
  } = props;

  const { classes } = useStylesTooltip();

  const placementLeft: TooltipPlacement | undefined = withLeftPlacement ? PLACEMENT_LEFT : undefined;
  const placementLeftEnd: TooltipPlacement | undefined = withLeftEndPlacement ? PLACEMENT_LEFT_END : undefined;
  const placementRight: TooltipPlacement | undefined = withRightPlacement ? PLACEMENT_RIGHT : undefined;

  return (
    isDisabled ? (
      <span>
        {children}
      </span>
    ) : (
      <TooltipInternal
        open={isOpen}
        arrow={withArrow}
        title={title || component}
        placement={placementLeft || placementLeftEnd || placementRight}
        classes={{
          popper: classes.tooltipPopper,
          tooltip: isInvisible ? classes.tooltipInvisible : classes.tooltip,
        }}
      >
        <span>
          {children}
        </span>
      </TooltipInternal>
    )
  );
});

export default Tooltip;
